import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FactoryIcon from '@mui/icons-material/Factory';

import masterDataService from '../service/masterData.service';
import { TaskResponsibleTypeEnum } from '../config/taskList';

export const getResponsibleList = async () => {
  const response = await masterDataService.responsibleList();

  const withIcon = response.map((item) => {
    switch (item.type) {
      case TaskResponsibleTypeEnum.USER:
        item.icon = <PersonIcon />;
        break;
      case TaskResponsibleTypeEnum.USERGROUP:
        item.icon = <GroupIcon />;
        break;
      case TaskResponsibleTypeEnum.WORKER:
        item.icon = <EngineeringIcon />;
        break;
      case TaskResponsibleTypeEnum.BUSINESSPARTNER:
        item.icon = <FactoryIcon />;
        break;
      default:
        item.icon = <> </>;
    }
    return item;
  });

  return withIcon;
};
